import { Util, Request } from "@xt/xtbase";
const { getOrigin } = Util;
const { XtAxios4 } = Request;

const URL = getOrigin("www") + "/sapi/v4/payment/fiat/";

/** 获取法币列表（按余额排序），用于与 fiatCurrencyIds、IP 合并得到允许展示的法币 */
export function getFiatListByBalance(config) {
  return XtAxios4.get(URL + "list/by-balance", config);
}
